// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"TabBar_tabBar__3AgWX","tab":"TabBar_tab__19Vyl","active":"TabBar_active__25soX","disabled":"TabBar_disabled__2twpK"};